export default __webpack_public_path__ + "static/material-symbols-c395011c2f72a61b1ec10f9d2535f4dd.png";